import React, { ReactNode } from "react";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { PersonFill } from "react-bootstrap-icons";
import styles from "./sidebar.module.scss";
import { Tooltip } from "../../atoms/tooltip";

interface SidebarProp {
  full_name?: string;
  items: {
    title: string;
    icon: ReactNode;
    href: string;
    enable?: boolean;
  }[];
}
export const Sidebar: React.FC<SidebarProp> = ({ full_name, items }) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className={styles.sidebar_background_container}>
      <div className={styles.sidebar_container}>
        <div>
          <div className="d-flex justify-content-between align-items-center gap-2">
            <div className={styles.title}>
              <PersonFill size={32} />
              <div>{full_name}</div>
            </div>
          </div>
          <br />
          <div className="d-flex flex-column gap-2">
            {items.map((item) => {
              return (
                <button
                  disabled={!item.enable}
                  className={classNames([
                    item.href === location.pathname && styles.active,
                  ])}
                  key={item.href}
                  onClick={() => {
                    navigate(item.href);
                  }}
                >
                  {!item.enable ? (
                    <Tooltip
                      placement={!item.enable ? "left" : "bottom"}
                      color={!item.enable ? "dark" : "light"}
                      title={
                        !item.enable ? (
                          <div>
                            برای دسترسی به این محتوا باید اهراز هویت کنید
                          </div>
                        ) : (
                          <div>{item.title}</div>
                        )
                      }
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div className={styles.icon_container}>{item.icon}</div>
                        <div>{item.title}</div>
                      </div>
                    </Tooltip>
                  ) : (
                    <div className="d-flex align-items-center gap-3">
                      <div className={styles.icon_container}>{item.icon}</div>
                      <div>{item.title}</div>
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
